import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-bottom: 120px;
  overflow: auto;
`;

export class NavigationWrapper extends Component {
  render() {
    const { children } = this.props;

    return (
      <Wrapper>
        {children}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationWrapper.js